import InGameAnalyticsWrap from "@home/pages/studio/inGameAnalytics/components/OldInGameAnalytics/component/InGameAnalyticsWrap";


export default {
  InGameAnalyticsWrap
};